import { useQuery } from "react-query";
import { useAppContext } from "../AppContext";
import { useState } from "react";
import {getSpecialtyClinicsData as getSpecialtyClinicsDataLocally, isSignedIn } from "../GraphService";
import { useParams } from "react-router-dom";
import { ExcelClinicInfo } from "../common/types";
import { ClinicsEnum } from "../common/enums";

type CalendarParams = {
  onyen: string;
};

export default function useSpecialtyClinics(usePrivateCalendar: boolean) {
  const app = useAppContext();
  const { onyen } = useParams<CalendarParams>();
  const [showSpecialty, setShowSpecialty] = useState<boolean>(false)
  const [availableSpecialtyClinics, setAvailableSpecialtyClinics] = useState<ClinicsEnum[]>([])
  const [isSpecialtyClinicLoading, setSpecialtyClinicLoading] = useState<boolean>(false)
  
  const { data: fetchedData, refetch, isLoading: isDoingFirstLoad } = useQuery<ExcelClinicInfo[]>(
    ['specialtyClinicData', usePrivateCalendar],
    async () => {
      setSpecialtyClinicLoading(true)
      try {
        if(isSignedIn() && usePrivateCalendar){
          const results = await getSpecialtyClinicsDataLocally(app.authProvider!);
            setSpecialtyClinicLoading(false);
          return results;
        }else if (usePrivateCalendar === false) {
          const results = await fetch(`${process.env.REACT_APP_API_URL}/user-specialtyClinics?userId=${onyen}`).then(res => res.json());
          setSpecialtyClinicLoading(false);
          return results;
        }
      }catch (e) {
        console.warn("Specialty clinic data unavailable")
        setAvailableSpecialtyClinics([]);
        setSpecialtyClinicLoading(false);
        return [];
      }
     
    }
  );

 

  const specialtyClinicData = fetchedData ?? []
  
  return {
    showSpecialty,
    setShowSpecialty,
    availableSpecialtyClinics,
    setAvailableSpecialtyClinics,
    refetch,
    isDoingFirstLoad,
    specialtyClinicData,
    isSpecialtyClinicLoading,
  }
}